module.exports = __webpack_public_path__ + "img/video.e8af6ba1.png";